module.exports = __webpack_public_path__ + "lp/img/speech_bubble.7cba5ed4.svg";